<div class="container" [appStoryblok]="_editable">
  <div class="row">
    <div class="col-12 col-lg-4 py-x gap d-flex flex-column">
      <h2 class="display-1">{{ title }}</h2>
      <div>
        <a
          *ngIf="link"
          class="btn btn-outline-primary btn-lg"
          [storyblokLink]="link"
          >{{ link_text || "Shop All" }}</a
        >
      </div>
    </div>
    <div class="col-12 col-lg-8 py-4">
      <div
        *ngFor="let blok of accordions; let last = last"
        [ngClass]="{ 'border-bottom': !last }"
      >
        <ndc-dynamic
          *ngIf="components"
          [ndcDynamicComponent]="components[blok.component]"
          [ndcDynamicInputs]="blok"
        >
        </ndc-dynamic>
      </div>
    </div>
  </div>
</div>
